import { render, staticRenderFns } from "./OnlineClassDictationV2.vue?vue&type=template&id=f01a1cf6&scoped=true&"
import script from "./OnlineClassDictationV2.vue?vue&type=script&lang=js&"
export * from "./OnlineClassDictationV2.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClassDictationV2.vue?vue&type=style&index=0&id=f01a1cf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01a1cf6",
  null
  
)

export default component.exports